import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 'M', label: 'March' },
    { value: 'E', label: 'June' },
    { value: 'J', label: 'July' },
    { value: 'S', label: 'September' },
  ],
});
